import { useField } from '@framework/form';
import { useCallback, useEffect } from 'react';
import { useMaterializeReference } from '../../../../../../expressions/evaluate/useMaterializeReference';
import { getHiddenSubsectionControlFieldName } from '../../../subsection/components/HiddenSubsectionComponent';
import { IButtonActionSubsectionOpen } from '../IButtonAction';
import { IButtonActionLogicComponentProps } from '../common/IButtonActionLogicComponentProps';

export function ButtonActionSubsectionOpenLogicComponent(
  props: IButtonActionLogicComponentProps<IButtonActionSubsectionOpen>,
) {
  const { action, buttonWidgetOptions, onClickSubject } = props;

  const materializedReference = useMaterializeReference(
    buttonWidgetOptions.name,
    action.subsectionReference,
  );

  const hiddenControlField = useField(
    getHiddenSubsectionControlFieldName(materializedReference.absolutePath),
  );

  const handleAction = useCallback(() => {
    if (!action.subsectionReference) {
      console.warn(
        `SubsectionOpenActionComponent: subsectionReference is not defined`,
      );
      return;
    }
    hiddenControlField.setValue(true, {
      shouldDirty: false,
      shouldTouch: false,
    });
  }, [action.subsectionReference, hiddenControlField]);

  useEffect(() => {
    const subscription = onClickSubject.subscribe(handleAction);
    return () => subscription.unsubscribe();
  }, [onClickSubject, handleAction]);

  return null;
}
